<template lang="html">
  <span class="p-1">
    <b-tooltip label="Add to collection" type="is-warning" position="is-left">
      <b-button @click="isComponentModalActive = true" class="is-warning is-inverted">
        <b-icon icon="star-face" size="is-big"></b-icon>
      </b-button>
    </b-tooltip>

    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <!-- Header -->
        <header class="modal-card-head">
          <p class="modal-card-title">Add to Collections</p>
        </header>

        <!-- Collections Selection -->
        <section class="modal-card-body">
          <div v-for="collection in collections" :key="collection.id">
            <b-checkbox
              :value="isInCollection(collection.attributes.collection_items)"
              @input="
                collectionChange(
                  $event,
                  collection.id,
                  collection.attributes.collection_items,
                  collection.attributes.name
                )
              "
            >
              {{ collection.attributes.name }}
            </b-checkbox>
          </div>
        </section>

        <!-- Footer -->
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalActive = false">
            Close
          </button>
        </footer>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { notificationMixin } from '@/mixins/notificationMixin'

export default {
  props: ['collectableId', 'collectableType'],
  mixins: [notificationMixin],
  data () {
    return {
      collections: null,
      isComponentModalActive: false
    }
  },
  methods: {
    addToCollection (collectionId, collectionName) {
      let data = {
        collectableType: this.collectableType,
        collectableId: this.collectableId,
        collectionId: collectionId
      }
      this.$store
        .dispatch('collectionItems/create', data)
        .then((resp) => {
          this.collections = resp.data.data
          this.actionSuccess(`Added to collection : ${collectionName}`)
        })
        .catch((_) => {
          console.log('Collection fetch error')
        })
    },
    removeFromCollection (collectionItems, collectionName) {
      let target = collectionItems.find((item) => {
        return (
          String(item.content.data.id) === String(this.collectableId) &&
          item.content.data.type === this.collectableType
        )
      })
      this.$store
        .dispatch('collectionItems/destroy', target.data.id)
        .then((resp) => {
          this.collections = resp.data.data
          this.actionSuccess(`Removed from collection : ${collectionName}`)
        })
        .catch((_) => {
          console.log('Collection destroy error')
        })
    },
    collectionChange (added, collectionId, collectionItems, collectionName) {
      if (added) {
        this.addToCollection(collectionId, collectionName)
      } else {
        this.removeFromCollection(collectionItems, collectionName)
      }
    },
    isInCollection (collectionItems) {
      return collectionItems.some((item) => {
        return (
          String(item.content.data.id) === String(this.collectableId) &&
          item.content.data.type === this.collectableType
        )
      })
    }
  },
  computed: {
    ...mapGetters({
      isOwner: 'isOwner',
      isLoggedIn: 'isLoggedIn',
      currentUser: 'currentUser'
    })
  },
  created () {
    this.$store
      .dispatch('users/collections/index', this.currentUser.attributes.username)
      .then((resp) => {
        this.collections = resp.data.data
      })
      .catch((_) => {
        console.log('Collection fetch error')
      })
  }
}
</script>

<style lang="css" scoped></style>
